const DURATION = 1500

function formatNumber(value, decimals, hasCommas) {
  const fixed = decimals > 0 ? value.toFixed(decimals) : Math.floor(value).toString()
  if (!hasCommas) return fixed
  const [int, dec] = fixed.split('.')
  const formatted = int.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  return dec ? `${formatted}.${dec}` : formatted
}

function animateCount(el) {
  const raw = el.dataset.count
  const hasCommas = raw.includes(',')
  const numeric = raw.replace(/,/g, '')
  const target = parseFloat(numeric)
  const isFloat = numeric.includes('.')
  const decimals = isFloat ? (numeric.split('.')[1]?.length ?? 0) : 0
  const start = performance.now()

  function step(now) {
    const progress = Math.min((now - start) / DURATION, 1)
    const eased = 1 - Math.pow(1 - progress, 5)
    el.textContent = formatNumber(target * eased, decimals, hasCommas)
    if (progress < 1) requestAnimationFrame(step)
    else el.textContent = raw
  }

  requestAnimationFrame(step)
}

const observer = new IntersectionObserver(entries => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      animateCount(entry.target)
      observer.unobserve(entry.target)
    }
  })
}, { threshold: 0.2 })

document.querySelectorAll('[data-count]').forEach(el => observer.observe(el))
